import React, { useState, useEffect } from 'react'; 

import { View, Text, Image, Button, StyleSheet,TouchableOpacity, ScrollView, TextInput, Linking } from 'react-native';
import NavBar from './navBar'; 
import { useNavigate } from 'react-router-dom';

import { globalData } from './globalData';  // Importa il modulo globale
import MenuPanel from './menuPanel';

import { useLocation } from 'react-router-dom';
  // Variabile "globale" di classe
  //let storedCurrentItem = null;
  //let storedCurrentSize = null;
const Cart = () => {

  const [error, setError] = useState(null);
  const navigate = useNavigate();
 

  const location = useLocation();
  let { currentItem, selectedSize} = location.state || {};
  var now = new Date();
  var dateStr = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

  // Genera un numero casuale di 6 cifre
  const randomNum = Math.floor(100000 + Math.random() * 900000);
  const randomNum1= Math.floor(100000 + Math.random() * 900);
  if(location.state != null){
     globalData.currentItem = currentItem;
     globalData.selectedSize = selectedSize;
  }
  if ( location.state == null && globalData.currentItem != null) {
  // Se route.params è null, utilizza la variabile globale (se esistente)
  //currentItem = storedCurrentItem;
  //selectedSize = storedCurrentSize;

  currentItem = globalData.currentItem;
  selectedSize = globalData.selectedSize;
} else {
  // Caso in cui non esistano valori validi
  console.warn('Nessun elemento corrente disponibile.');
}
 // Combina il nome, la taglia, la data e il numero casuale
 const codTrans = `COD_${dateStr}`;


const PostData = async () => {

  console.warn('dentro il post');

  var countS=currentItem.quantityS;
  var countM=currentItem.quantityM;
  var countL=currentItem.quantityL;
  var id = currentItem.productType.id;
 if(selectedSize=="S"){
  countS= countS-1;

 }else if(selectedSize=="M"){
  countM= countM-1;
 }else {
  countL= countL-1;
 }
  try {
    const response = await fetch('/proxyPost.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
     
      body: JSON.stringify({
        id: id.toString(),
        numberS: countS.toString(),
        numberM: countM.toString(),
        numberL: countL.toString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const jsonData = await response.json(); // Leggi i dati JSON restituiti dal server
    console.log(jsonData); // Stampa i dati
   
    console.log('Request sent successfully');
  } catch (err) {
    setError(err.message);
  }
};


const PostCartToDb = async () => {
  try {
    const response = await fetch('/proxyPostCartToDB.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
     
      body: JSON.stringify({
         shippingType: globalData.shippingType?.toString() || "",
     currentItemID: globalData.currentItem?.productType.id?.toString() || "",
     currentItemName: globalData.currentItem?.productType.name?.toString() || "",
     currentItemPrice: globalData.currentItem?.productType.price?.toString() || "",
     selectedSize: globalData.selectedSize.toString(),
    nome: globalData.shippingData?.nome?.toString() || "",
    cognome: globalData.shippingData?.cognome?.toString() || "",
    postalCode: globalData.shippingData?.postalCode?.toString() || "",
    locality: globalData.shippingData?.locality?.toString() || "",
    province: globalData.shippingData?.province?.toString() || "",
    via: globalData.shippingData?.via?.toString() || "",
    email: globalData.shippingData?.email?.toString() || "",
    phone: globalData.shippingData?.phone?.toString() || "",
    codTrans: codTrans?.toString() || "",
    pagato: "NO".toString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
   
   
    console.log('Request sent successfully');
  } catch (err) {
    setError(err.message);
  }
};

const CallNexi = async () => {
  var name = currentItem.productType.name;
  var taglia = selectedSize;
  console.log("Name:", name);
  console.log("Taglia:", taglia);
  console.log("Total Price:", totalPrice);
  console.log("CodTrans:", codTrans);

  try {
    const response = await fetch('/pagamento.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
     
      body: JSON.stringify({
        id: "0",
        taglia: "S",
        prezzo: "589,00",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    console.log('Request sent successfully');
    const url = `/pagamento.php?nome=${name}&taglia=${taglia}&prezzo=${totalPrice}&codTrans=${codTrans}`;

// Reindirizziamo alla pagina
  window.location.href = url; 

  } catch (err) {
    setError(err.message);
  }
};

const CallNexiTest = async () => {
  var name = currentItem.productType.name;
  var taglia = selectedSize;
  console.log("Name:", name);
  console.log("Taglia:", taglia);
  console.log("Total Price:", totalPrice);
  console.log("CodTrans:", codTrans);

  try {
    const response = await fetch('/pagamento.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
     
      body: JSON.stringify({
        id: "0",
        taglia: "S",
        prezzo: "589,00",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    let price= 3.98;
    console.log('Request sent successfully');
    const url = `/pagamento.php?nome=${name}&taglia=${taglia}&prezzo=${price}&codTrans=${codTrans}`;

// Reindirizziamo alla pagina
  window.location.href = url; 

  } catch (err) {
    setError(err.message);
  }
};

const handleButtonClick = async () => {
  try {
    await PostCartToDb();
  } catch (error) {
    console.error("Errore durante PostCartToDb:", error.message);
    return;
  }

  try {
    await CallNexi();
  } catch (error) {
    console.error("Errore durante CallNexi:", error.message);
  }
};

const handleButtonClickTest = async () => {
 
  try {
    await CallNexiTest();
  } catch (error) {
    console.error("Errore durante CallNexi:", error.message);
  }
};

useEffect(() => {
  if (currentItem) {
    globalData.setCurrentItem(currentItem); // Imposta l'elemento corrente
    globalData.setSelectedSize(selectedSize); // Imposta la taglia selezionata
  }
}, [currentItem, selectedSize]);

const [shippingData, setShippingData] = useState(globalData.shippingData); // Usa i dati globali come stato iniziale

  const [isFull, setIsFull] = useState(currentItem != null);
  console.error('current:'+ isFull);
  // const [shippingData, setShippingData] = useState({
  //   nome: '',
  //   cognome: '',
  //   postalCode: '',
  //   locality: '',
  //   province: '',
  //   via: '',
  //   email: '',
  //   phone: '',
  // });

const TestMailCheckout = async () => {
  try {
    const message = `
    Dati del prodotto:
    Nome: ${productType.name}
    Prezzo: € ${productType.price.toFixed(2)}

    Tipo di spedizione: ${shippingType === 'free' ? 'Gratis' : '10,00€'}
    Totale: € ${totalPrice.toFixed(2)}
  `;

    const response = await fetch('/sendemail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: shippingData.mail,
        subject: 'Conferma acquisto',
        message: message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonData = await response.json();
   console.error('Email inviata con successo');
   PostData();
  } catch (error) {
    console.error('Errore nell\'invio dell\'email:', error);
   
  }
};

  const [isAllFillesValid, setIsAllFillesValid]= useState(null);
  const [shippingType, setShippingType] = useState(null); 
  const [isFormValid, setIsFormValid] = useState(false);
  const handleNavigateToProducts = () => {
  
    const direction="PageProducts";
    navigate(`/${direction.toLowerCase()}`);
  };
  const handleInputChange = (field, value) => {
   
    setShippingData(prevData => {
      const updatedData = { ...prevData, [field]: value };
      const allFieldsFilled = Object.values(updatedData).every(fieldValue => fieldValue.trim() !== '');
      setIsAllFillesValid(allFieldsFilled);
      setIsFormValid(allFieldsFilled && (shippingType==='premium' || shippingType==='free'|| value==='loaker'));
      globalData.setShippingData(updatedData);

      return updatedData;
    });
  };

  const handleSpedizioni = (value) => {
    console.log("il value è " , value);
    setShippingType(value);
    globalData.setShippingType(value);
    setIsFormValid(isAllFillesValid && (value==='premium' || value==='free' || value==='loaker'));
  };

  const productType = currentItem 
    ? currentItem.productType
    : null;

  // Calcolo del totale
  const totalPrice = productType ? productType.price + (shippingType === 'premium' ? 10 : 0) : 0;

  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);
  return (
    <View style={styles.container}>
      
      <NavBar toggleMenu={toggleMenu} />
      <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />
     
      {isFull && (
         <ScrollView style={styles.innerView}>
        
          <View style={styles.productContainer}>
            {productType && <Image source={productType.imgPath1} style={styles.productImage} />}
            <View style={styles.productDetails}>
              <Text style={styles.productName}>{productType?.name}</Text>
              <Text style={styles.productSize}>Taglia: {selectedSize}</Text>
              <Text style={styles.productPrice}>€ {productType?.price.toFixed(2)}</Text>
            </View>
          </View>
       
            <View style={styles.shippingContainer}>
              <Text style={styles.shippingTitle}>Dati di Spedizione</Text>
              <TextInput
                style={styles.input}
                placeholder="Nome"
                value={shippingData.nome}
                onChangeText={text => handleInputChange('nome', text)}
              />
               <TextInput
                style={styles.input}
                placeholder="Cognome"
                value={shippingData.cognome}
                onChangeText={text => handleInputChange('cognome', text)}
              />
              <TextInput
                style={styles.input}
                placeholder="Codice Postale"
                value={shippingData.postalCode}
                onChangeText={text => handleInputChange('postalCode', text)}
              />
             
               <TextInput
                style={styles.input}
                placeholder="Città "
                value={shippingData.locality}
                onChangeText={text => handleInputChange('locality', text)}
              />
              <TextInput
                style={styles.input}
                placeholder="Provincia"
                value={shippingData.province}
                onChangeText={text => handleInputChange('province', text)}
              />
                <TextInput
                style={styles.input}
                placeholder="Indirizzo/ Nome-Locker"
                value={shippingData.via}
                onChangeText={text => handleInputChange('via', text)}
              />
              <TextInput
                style={styles.input}
                placeholder="Email"
                value={shippingData.email}
                onChangeText={text => handleInputChange('email', text)}
              />
             
              <TextInput
                style={styles.input}
                placeholder="Telefono +39"
                value={shippingData.phone}
                onChangeText={text => handleInputChange('phone', text)}
              />
      </View>

            <View style={styles.shippingTypeContainer}>
              <Text style={styles.shippingTypeTitle}>Tipo di Spedizione</Text>
              <View style={styles.shippingTypeOptions}>

              <TouchableOpacity
      onPress={() =>  handleSpedizioni('loaker')}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: shippingType === 'loaker'  ? '#000' : '#fff',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: shippingType === 'loaker' 
        ? '#fff'  // Colore bianco se la taglia è selezionata
        : '#000', // Colore nero se la taglia non è selezionata
    }}
  >
    Presso un locker (IN POST)
  </Text>
    </TouchableOpacity>
                <Text style={styles.shippingInfo}>Prezzo: Gratuita, spedizione presso punto Locker IN POST, Tempi di spedizione: 2-4 giorni lavorativi</Text>

              <TouchableOpacity
      onPress={() =>  handleSpedizioni('free')}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: shippingType === 'free'  ? '#000' : '#fff',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: shippingType === 'free' 
        ? '#fff'  // Colore bianco se la taglia è selezionata
        : '#000', // Colore nero se la taglia non è selezionata
    }}
  >
    Standard
  </Text>
    </TouchableOpacity>

                <Text style={styles.shippingInfo}>Prezzo: Gratuita, spedizione presso domicilio, Le spedizioni partiranno dopo data 3 gennaio, Tempi di spedizione: 5-7 giorni lavorativi</Text>

                {/* <TouchableOpacity
      onPress={() =>  handleSpedizioni('premium')}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: shippingType === 'premium'  ? '#000' : '#fff',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color:
        shippingType === 'premium' 
        ? '#fff'  // Colore bianco se la taglia è selezionata
        : '#000', // Colore nero se la taglia non è selezionata
    }}
  >
    Premium
  </Text>
    </TouchableOpacity> */}
{/*                
                <Text style={styles.shippingInfo}>Prezzo: 10,00€, spedizione presso domicilio, Arrivo in 24/48 ore dalla spedizione</Text> */}
              </View>
            </View>
 
            {isFormValid && (

            <View style={styles.orderSummary}>
              <Text style={styles.summaryText}>{productType?.name} - € {productType?.price.toFixed(2)}</Text>
              <Text sty
              le={styles.summaryText}>Spedizione: {shippingType === 'premium' ? '10,00€' : 'Gratis' }</Text>
              <Text style={styles.summaryText}>Totale: € {totalPrice.toFixed(2)}</Text>
            </View>
            )}

            {!isFormValid && (
              <Text style={styles.warningText}>Verifica di aver compilato correttamente tutti i dati relativi alla spedizione e di aver selezionato il tipo di spedizione che preferisci.</Text>
            )}

{/* <TouchableOpacity
      onPress={CallNexi}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: !isFormValid ?'#ccc': '#000',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: '#fff'  // Colore bianco se la taglia è selezionata
    }}
  >
TestNexi  </Text>
    </TouchableOpacity> */}

<TouchableOpacity
 disabled={!isFormValid}
      onPress={handleButtonClick}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: !isFormValid ?'#ccc': '#000',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: '#fff'  // Colore bianco se la taglia è selezionata
    }}
  >
 Acquista  </Text>
    </TouchableOpacity>
    <TouchableOpacity
 disabled={!isFormValid}
      onPress={handleButtonClickTest}
      style={{
        width:' 100%', // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 0,
        borderWidth: 0,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: !isFormValid ?'#ccc': '#000',
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: '#fff'  // Colore bianco se la taglia è selezionata
    }}
  >
 Acquista TEST </Text>
    </TouchableOpacity>
        </ScrollView>
         )}
        {!isFull && (
          <View style={styles.containerEmpty}>
          <View style={styles.contentEmpty}>
            <Image 
              source={require('./assets/images/bianca1.jpg')} // Sostituisci con l'immagine del carrello vuoto
              style={styles.cartImage}
            />
            <Text style={styles.emptyCartText}>Il tuo carrello è vuoto</Text>
            <Text style={styles.subText}>
              Sembra che non hai ancora aggiunto nulla al carrello.
            </Text>
            <TouchableOpacity style={styles.shopButton} onPress={handleNavigateToProducts}>
              <Text style={styles.shopButtonText}>Scopri i nostri prodotti</Text>
            </TouchableOpacity>
          </View>
        </View>
        )}

     
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flexGrow: 1,
    padding: 16,
    backgroundColor: '#fff',
    fontFamily: 'Arial',  // Font uniforme
  },
  innerView: {
    marginTop:40,
    paddingTop: 20,
    paddingLeft: 5, 
    paddingRight: 5, 
  },
  productContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start', // Allineamento a sinistra
    marginBottom: 20,
    marginTop:60,
    borderBottomWidth: 1,
    borderBottomColor: '#ddd',
    paddingBottom: 10,
    width: '100%',
  },
  productImage: {
    width: 60,
    height: 60,
    marginRight: 16,
  },
  productDetails: {
    flex: 1,
  },
  productName: {
    fontSize: 14,  // Font ridotto
    fontWeight: 'bold',
  },
  productSize: {
    fontSize: 12,  // Font ridotto
    color: '#666',
  },
  productPrice: {
    fontSize: 14,  // Font ridotto
    color: '#000',
    fontWeight: 'bold',
  },
  shippingContainer: {
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
  shippingTitle: {
    fontSize: 16,  // Font ridotto
    fontWeight: 'bold',
    marginBottom: 10,
  },
  input: {
    fontSize: 14,  // Font ridotto
    color: '#333',
    borderBottomWidth: 1,
    borderBottomColor: '#ddd',
    marginBottom: 15,
    padding: 10,
    width: '100%',
  },
  shippingTypeContainer: {
    marginTop: 20,
    width: '100%',
  },
  shippingTypeTitle: {
    fontSize: 16,  // Font ridotto
    fontWeight: 'bold',
    marginBottom: 10,
  },
  shippingTypeOptions: {
    flexDirection: 'column',  // Disposizione verticale
    justifyContent: 'flex-start',
    width: '100%',
  },
  shippingInfo: {
    fontSize: 12,  // Font ridotto
    color: '#333',
    marginBottom: 15,
  },
  emptyCart: {
    fontSize: 18,
    color: 'red',
    marginTop: 20,
  },
  orderSummary: {
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
  summaryText: {
    fontSize: 14,
    color: '#000',
    marginBottom: 5,
  },
  warningText: {
    fontSize: 14,
    color: 'red',
    marginBottom: 15,
  },
  containerEmpty: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    marginTop:60,
  },
  contentEmpty: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    padding: 30,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  cartImage: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
  emptyCartText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  subText: {
    fontSize: 14,
    color: '#555',
    textAlign: 'center',
    marginBottom: 20,
  },
  shopButton: {
    backgroundColor: '#000',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  shopButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default Cart;
